import Divider from '@zenbusiness/zui/Divider';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

const ContainerStyle = ({ theme, isDragAccept, hasErrors, isDragEnter, isDragReject }) => {
  const borderColor = hasErrors ? theme.palette.error.main : theme.palette.border.main;
  return {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      maxWidth: '588px'
    },
    padding: 16,
    borderWidth: 2,
    borderStyle: isDragAccept || isDragEnter ? 'dashed' : 'solid',
    borderColor: isDragAccept || isDragEnter ? theme.palette.fixed.black : borderColor,
    backgroundColor: `${
      isDragAccept || isDragReject
        ? theme.palette.background.cyan.main
        : theme.palette.background.grey.main
    }`,
    borderRadius: 16
  };
};

const DividerStyle = () => ({
  marginTop: 25
});

export const ContainerStyled = styled(Stack, {
  shouldForwardProp: (prop) =>
    prop !== 'hasErrors' &&
    prop !== 'isDragEnter' &&
    prop !== 'isDragAccept' &&
    prop !== 'isDragReject'
})(ContainerStyle);

export const DividerStyled = styled(Divider)(DividerStyle);
